import _ from "lodash";

import * as addEmailTemplate from '@/api/crm/emailTemplates/addEmailTemplate';
import * as updateEmailTemplate from '@/api/crm/emailTemplates/updateEmailTemplate';
import * as deleteEmailTemplate from '@/api/crm/emailTemplates/deleteEmailTemplate';
import * as getEmailTemplates from '@/api/crm/emailTemplates/getEmailTemplates.js';


export default {
    namespaced: true,
    state: {
        //consentTypes: ["Personal Data", "Analytics", "Enrichment", "Email", "Phone", "SoMe", "Snail Mail", "Marketing"],
        emailTemplates: []

    },
    mutations: {
        gotEmailTemplates(state, result) {
            state.emailTemplates = result;
        },
    },
    actions: {
        async getAll({ commit, getters }, force = true) {
            if (!force && getters.emailTemplates.length > 0) return;
            const result = await getEmailTemplates.get();
            if (result) commit("gotEmailTemplates", result);
        },
        async create({ dispatch }, dto) {
            await addEmailTemplate.post(dto);
            await dispatch("getAll")
        },
        async update({ dispatch }, dto) {
            await updateEmailTemplate.put(dto);
            await dispatch("getAll")
        },
        async delete({ dispatch }, id) {
            await deleteEmailTemplate.del(id);
            await dispatch("getAll")
        },

    },
    getters: {
        emailTemplate: state => (id) => state.emailTemplates.find(e => e.id === id),
        emailTemplates: state => state.emailTemplates,
    }
};
